<template>
  <div
    ref="cta"
    class="tw-w-full tw-my-4 tw-no-underline tw-text-white"
  >
    <img
      v-if="loading"
      src="https://assets.stihldealer.net/common/spinner.svg"
      style="width: 50px; margin: auto"
      alt="loading icon"
    >
    <button
      v-if="!loading && ((!isOutfitters && variant.allowPurchase && express) || (isOutfitters && (variant.inventory ?? 0) > 0))"
      type="submit"
      class="button-default-inverse tw-font-title tw-text-center tw-text-sm tw-p-5 tw-w-full tw-text-white"
      @click="showLoader()"
    >
      Add To Cart
    </button>
    <button
      v-else-if="!loading && (isOutfitters && (variant.inventory ?? 0) <= 0)"
      class="button-default-noautohover tw-font-title tw-text-center tw-text-sm tw-p-5 tw-w-full tw-text-white tw-m-0 tw-block tw-no-underline"
      disabled
    >
      Not Available
    </button>
    <a
      v-else-if="!loading && (!isOutfitters && (!variant.allowPurchase || !express))"
      :href="`/contactus/?product=${sku}`"
      class="button-default-inverse tw-font-title tw-text-center tw-text-sm tw-p-5 tw-w-full tw-text-white tw-m-0 tw-block tw-no-underline"
    >
      Contact Us For Availability
    </a>
  </div>
</template>
<script>
export default {
  props: {
    variant: {
      type: Object,
      required: true
    },
    express: {
      type: Boolean,
      required: true
    },
    isOutfitters: {
      type: Boolean,
      required: true
    },
    sku: {
      type: String,
      required: true
    }
  },
  data() {
    return { loading: false }
  },
  methods: {
    showLoader() {
      this.loading = true
      const form = this.$refs.cta.closest('form')
      //fallback to trigger form submit in case propogation fails
      if (form) {
        form.submit()
      }
    }
  }
}
</script>